import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { gerenciaTecnicaSlice, selectGtoState, useDispatch } from 'src/stateManagement/redux';
import { WrapMain } from 'src/shared/modules/wrap_main'
import { Box, LinearProgress, Tab, Tabs } from '@mui/material';
import ButtonCircle from "../../../../../shared/components/button_circle";
import Grid from "@mui/material/Grid2";
import { PendingRequirementsComponent } from './pending_requirements';
import { AnalistsComponent } from './analists';
import { getAnalyzedByDate, getPendingRequirementsByDate } from 'src/shared/util/requestDataServer';

export const AnalystSummary = () => {

    const navigate = useNavigate();

    const [loading, setloading] = useState(false)

    const dispatch = useDispatch();

    const mainState = useSelector(selectGtoState);

    const [requirements, setRequirements] = useState<any[]>([])

    const [analyzed, setAnalyzed] = useState<any[]>([])

    const [value, setValue] = useState(0);
    
    const [finishedRequirements, setFinishedRequirements] = useState(false)
    const [finishedAnalyzed, setFinishedAnalyzed] = useState(false)

    useEffect(() => {
        if (finishedRequirements && finishedAnalyzed) {
            setloading(false);
        }
    }, [finishedRequirements, finishedAnalyzed])
    

    useEffect(() => {

        const filters = mainState.reportFilters;
        const report = mainState?.reportFilters?.activeReport;

        if (!report || !filters) {
            handleGoToDashboard();
        } else if (filters.startDate && filters.endDate) {
            setloading(true);
            setFinishedRequirements(false);
            setFinishedAnalyzed(false);
            getPendingRequirementsByDate(filters.startDate, filters.endDate, filters.projectId).then((data) => {
                if (data) {
                    setRequirements(data);
                }
            }).finally(() => {
                setFinishedRequirements(true);
            });

            getAnalyzedByDate(filters.startDate, filters.endDate, filters.projectId).then((data) => {
                if (data) {
                    setAnalyzed(data);
                }
            }).finally(() => {
                setFinishedAnalyzed(true);
            });
        }
    }, [mainState.reportFilters])

    const handleGoToDashboard = () => {
        dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
        navigate('/gto/dashboard')
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <WrapMain>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                }}
            >
                {/* Title */}
                <Box className="history_task_container_header">
                    <ButtonCircle
                        icon="/assets/icons/back.svg"
                        iconHeight={50}
                        iconWidth={50}
                        onClick={() => handleGoToDashboard()}
                    />
                    <Box className="history_task_container_title">
                        Relacion de Analisis
                    </Box>
                </Box>
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Loading....
                        </Box>
                    </>
                )}
                <Box sx={{ width: "100%" }}>
                    <Grid container spacing={2} sx={{ padding: "10px 50px" }}>
                        <Grid size={12}>
                            <Box>
                                {/* Tabs */}
                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: "divider",
                                    }}
                                >
                                    <Tabs value={value} onChange={handleChange}>
                                        <Tab label="Analisis" />
                                        <Tab label="Requerimientos Pendientes" />
                                    </Tabs>
                                </Box>
                            </Box>
                            <AnalistsComponent value={value} inputData={analyzed} report={mainState?.reportFilters?.activeReport} reportFilters={mainState?.reportFilters} />
                            <PendingRequirementsComponent value={value} requirements={requirements} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </WrapMain>
    )
}
